import { Intervention } from '@/app/components/action-plan/types';

export function getInterventionRiskData(intervention: Intervention) {
  const cancersAffected = intervention.riskImpact.filter(({ cancerType }) => cancerType !== 'overall');
  const overallRisk = intervention.riskImpact.find(({ cancerType }) => cancerType === 'overall');

  return {
    ...intervention,
    affectedCancersCount: cancersAffected.length,
    hasOverallRisk: !!overallRisk,
    highestImpact:
      cancersAffected.length > 0
        ? Math.max(0, ...cancersAffected.map(({ impact }) => impact).filter((impact) => impact))
        : overallRisk?.impact || 0,
  };
}
